export default "__VITE_ASSET__D9duyvlZ__"